<script setup lang="ts">
import { computed, onBeforeMount, useRuntimeConfig } from '#imports';
import { MAIN_TITLE } from '@/shared/constant';
import { useUserAuthStore } from '@/entities/User/store/auth';

const config = useRuntimeConfig();
const siteUrl = computed(() => `https://${config.public.SITE_URL as string}`);

const { refresh, profile, resetProfileData } = useUserAuthStore();

// TODO: по идеи не отрабатывает catch, заработает после правки fetchInstance
onBeforeMount(async () => {
	await refresh()
		.then(async () => profile())
		.catch(() => resetProfileData());
});
</script>

<template>
	<Html lang="ru">
		<Head>
			<Title>{{ MAIN_TITLE }}</Title>
			<Meta name="charset" content="utf-8" />
			<Meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no" />
			<Meta name="description" content="Первое в новейшей российской истории комплексное изучение проблем появления, становления и развития ислама в России." />
			<Meta name="keywords" content="медина, medina, энциклопедия, ислам, издательский дом" />
			<Meta name="yandex-verification" content="ccbe128c92ff1b88" />

			<Meta property="og:url" :content="siteUrl" />
			<Meta property="og:title" :content="MAIN_TITLE" />
			<Meta property="og:description" content="Первое в новейшей российской истории комплексное изучение проблем появления, становления и развития ислама в России." />

			<Link rel="icon" type="image/x-icon" href="/favicon.ico" />
		</Head>
		<Body>
			<nuxt-loading-indicator :height="2" color="#39db7f" />
			<nuxt-layout>
				<nuxt-page />
			</nuxt-layout>
		</Body>
	</Html>
</template>

<style lang="scss">
:root {
	--p-skeleton-background: #f9f9f9;
	--p-skeleton-animation-background: #ecebeb;
}
</style>
